import { useQuery } from '@tanstack/react-query';
import { scoresApi } from '../api/scores';

export function useLeaderboardPoll(eventId: string | undefined) {
  return useQuery({
    queryKey: ['leaderboard', eventId],
    queryFn: () => scoresApi.leaderboard(eventId!),
    enabled: !!eventId,
    refetchInterval: 30_000,
    refetchOnWindowFocus: true,
  });
}
